import { INTEGRATION_CATEGORY_LIST } from '@components/integration/defs';
import { Stack } from '@defs/stack';

// Interfaces
export interface Customer {
  address: string;
  assetIntelligenceAccess: boolean;
  biRegion: string;
  businessIntelligenceAccess: boolean;
  createdDate?: Date;
  domains: string[];
  email: string;
  emailPassword?: string;
  emailVerified?: boolean;
  appRegionPrefix: string;
  firstName: string;
  fleetIntelligenceAccess: boolean;
  hasIdentityProvider: boolean;
  id: number;
  integrationCadAccess: boolean;
  integrationFleetAccess: boolean;
  lastName: string;
  name: string;
  phone: string;
  status: number;
  safetyIntelligenceAccess: boolean;
  stack: Stack;
  tenantGroupName: string;
  tenantKey: string;
  timezone: string;
  vehicleIntelligenceUrl: string;
  vehicleIntelligenceAccess: boolean;
}

export interface CustomerName {
  name: string;
  tenantKey: string;
}

export interface CustomerStatus {
  id: number;
  name: string;
}

export interface OrgUsersPasswordDeleteDTO {
  domains: string[];
  includeCrew: boolean;
  includeUsers: boolean;
}

export interface UniqueValidator {
  name: string;
}

export interface AwsRegionInfo {
  code: string;
  full_name: string;
  name: string;
  public: boolean;
  zones: string[];
}

export interface IdentityProvider {
  alias: string;
  clientAuthentication: string;
  clientId: string;
  clientSecret: string;
  scopes: string;
  prompt: string;
  identityProviderConfigDTO: IdentityProviderConfig;
}

export interface IdentityProviderConfig {
  discoveryUrl: string;
  authorizationUrl: string;
  tokenUrl: string;
  logoutUrl: string;
  userInfoUrl: string;
  issuer: string;
  jwksUrl: string;
}

export const INTEGRATIONS_LIST = {
  CAD: {
    type: INTEGRATION_CATEGORY_LIST.OPERATIONAL,
    label: 'CAD',
    property: 'integrationCadAccess',
  },
  FLEET: {
    type: INTEGRATION_CATEGORY_LIST.OPERATIONAL,
    label: 'Fleet',
    property: 'integrationFleetAccess',
  },
} as const;

export enum RestrictedCustomerProperty {
  key = 'Customer Key',
  enabled = 'Enabled',
  stack = 'Stack',
  applications = 'Applications',
  integrations = 'Integrations',
  viUrl = 'Vehicle IntelligenceUrl',
  idp = 'Identity Provider',
  biRegion = 'BI Region',
  appPrefix = 'APP Prefix',
}

export enum CustomerValidatorProperty {
  name = 'name',
  key = 'key',
  url = 'url',
  email = 'email',
}

export const CLIENT_AUTHENTICATION = {
  clientSecretPost: { label: 'Client secret sent as post', value: 'client_secret_post' },
  clientSecretBasicAuth: {
    label: 'Client secret sent as basic auth',
    value: 'client_secret_basic',
  },
  // jwtSignedWithClientSecret: { label: 'JWT signed with client secret', value: 'client_secret_jwt' },
  // jwtSignedWithPrivateKey: { label: 'JWT signed with private key', value: 'private_key_jwt' },
} as const;

export const PROMPT = {
  unspecified: { label: 'Unspecified', value: 'unspecified', description: 'Unspecified' },
  none: {
    label: 'None',
    value: 'none',
    description: 'No authentication or consent',
  },
  consent: {
    label: 'Consent',
    value: 'consent',
    description: 'Forces the consent screen to be shown again',
  },
  login: { label: 'Login', value: 'login', description: 'Forces the user to re-authenticate' },
  selectAccount: {
    label: 'Select Account',
    value: 'select_account',
    description: 'Prompts the user to select an account',
  },
} as const;
